import React from "react";
import { Divider, Stack } from "@mui/material";

import { HubHookFormNumberInput } from "../../components";
import { useStationListWithCache } from "../../components/StationHookFormSelect";
import { LaborMaterialsTable } from "../../tables";

const LaborFields = ({
  scrapped = 0,
  completed = 0,
  sampleWeight = 0,
  heatCode = "",
  quantity = 0,
  available = 0,
  station,
  laborId,
}) => {
  const rules = {
    max: {
      value: quantity,
      message:
        "Value cannot be larger than work order quantity (El valor no puede ser mayor de la cantidad del orden de trabajo)",
    },
  };

  const sharedProps = {
    rules,
    required: true,
    endAdornment: `/${available}`,
  };

  return (
    <Stack gap="15px" width="100%" justifyContent="center" alignItems="center">
      <Stack
        gap="15px"
        width="100%"
        justifyContent="center"
        alignItems="start"
        direction="row"
      >
        <HubHookFormNumberInput
          name="scrapped"
          label="Scrapped (Rechazado)"
          defaultValue={scrapped || 0}
          {...sharedProps}
        />
        <HubHookFormNumberInput
          name="completed"
          label="Completed (Terminado)"
          defaultValue={completed || 0}
          {...sharedProps}
        />
        {!!station?.requestSampleWeight && (
          <HubHookFormNumberInput
            name="sampleWeight"
            label="Sample Weight (Peso de la Muestra)"
            defaultValue={sampleWeight || 0}
            required={station?.requestSampleWeight > 1}
            endAdornment="g"
            isNumber={false}
            isDecimal
          />
        )}
        {!!station?.requestHeatCode && (
          <HubHookFormNumberInput
            name="heatCode"
            label="Heat Code (Código de Metal)"
            defaultValue={heatCode}
            isNumber={false}
            required={station?.requestHeatCode > 1}
          />
        )}
      </Stack>
      {!!station?.requestMaterials && (
        <>
          <Divider
            orientation="horizontal"
            sx={{ width: "100%", maxWidth: "630px" }}
          />
          <LaborMaterialsTable
            laborId={laborId}
            required={station?.requestMaterials > 1}
          />
        </>
      )}
    </Stack>
  );
};

export default LaborFields;
